import { PottedPlant } from '../parts/greenery'
import type { AssetContext, AssetDefinition } from '../types'

/**
 * Small desktop plant: the shared `desk` potted-plant silhouette, offered with a
 * white or a charcoal pot. Origin at the centre of the pot, y = 0 at the surface
 * it stands on, so it stacks straight onto a desk or a credenza.
 */
function PlantDesk({ variant = 'white' }: AssetContext) {
  return <PottedPlant variant="desk" potTone={variant === 'dark' ? 'darkSoft' : 'shell'} />
}

export const definition: AssetDefinition = {
  id: 'plant-desk',
  name: 'Planta de escritorio',
  category: 'decor',
  footprint: [0.24, 0.24],
  height: 0.34,
  stackable: true,
  variants: [
    { id: 'white', name: 'Maceta blanca' },
    { id: 'dark', name: 'Maceta oscura' },
  ],
  keywords: ['planta', 'maceta', 'escritorio', 'verde', 'plant', 'desk plant', 'pot'],
  Component: PlantDesk,
}
